import { Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePersistentSnackbar } from '~/api/helpers';
import { useUploadDispatch } from '~/contexts/upload';
import type { UploadState } from './UploadDialog';

// TODO: Move this to the uploader
export const UploadSnackbar = () => {
  const { enqueueSnackbar } = useSnackbar();
  const persistentSnackbar = usePersistentSnackbar();
  const { t } = useTranslation();
  const uploadDispatch = useUploadDispatch();

  useEffect(() => {
    const listener = (file: string, status: UploadState) => {
      switch (status) {
        case 'pending':
          enqueueSnackbar(
            <Typography color="inherit">
              {t('components.upload_snackbar.pending', { file })}
            </Typography>,
            { variant: 'info' },
          );
          break;
        case 'finished':
          enqueueSnackbar(
            <Typography color="inherit">
              {t('components.upload_snackbar.finished', { file })}
            </Typography>,
            { variant: 'success' },
          );
          break;
        case 'canceled':
          // A cancelled upload is a failure the user has to act on, so it stays until dismissed.
          persistentSnackbar(t('components.upload_snackbar.canceled', { file }), {
            variant: 'warning',
          });
          break;
      }
    };
    uploadDispatch({ type: 'addListener', listener });
    return () => uploadDispatch({ type: 'removeListener', listener });
  }, [enqueueSnackbar, persistentSnackbar, t, uploadDispatch]);

  return null;
};
